type CompatibleValue = number | string | boolean | undefined;
type QueryObject = Record<string, CompatibleValue | CompatibleValue[]>;

export function serializeQuery(query: QueryObject): URLSearchParams {
  const queryWithStrings = Object.fromEntries(
    Object.entries(query)
      .filter(e => !!e[1])
      .map(([k, v]) => {
        if (Array.isArray(v)) {
          return [k, v.join(", ")];
        } else {
          return [k, v!.toString()];
        }
      })
  );

  return new URLSearchParams(queryWithStrings);
}
